<template>
  <CCardBody>
    <ul class="py-1">
      <li class="d-flex justify-content-between" v-if="card">
        <span class="font-weight-bold"> {{ $t('manageplan.component.card.payment-method.creditCard') }}</span>
        <span class="font-weight-normal">
          <CIcon v-if="card.brand" :name="card.brand" size="custom-size" :height="30" viewBox="0 0 32 32" />
          **** **** **** {{ card.last4 }}
        </span>
      </li>
      <li class="d-flex justify-content-between">
        <span class="font-weight-bold"> {{ $t('manageplan.component.card.payment-method.subTotal') }}</span>
        <span class="font-weight-normal">{{ mount ? formatNumber(mount) : '' }} €</span>
      </li>
      <li class="d-flex justify-content-between">
        <span class="text-gray-800 font-weight-bold"
          >{{ $t(`manageplan.component.card.subTotal.tax`) }}
          <CButton
            v-c-tooltip.hover="{
              content: `Placement`,
              placement: 'right-end',
            }"
            class="p-0 m-0"
          >
            <CIcon name="question" size="custom-size" :height="15" viewBox="0 0 32 32" class="mr-3" />
          </CButton>
        </span>
        <span class="text-gray-600">{{ tax ? tax : $t(`manageplan.component.card.subTotal.text-tax`) }} % </span>
      </li>
    </ul>
  </CCardBody>
</template>

<script>
import { mapState } from 'vuex'
import { currencyFormat, currencyFormatStyleEnum } from '@/utils/numbersFormatUtil.js'

export default {
  name: 'CardPayment',
  props: {},

  computed: {
    ...mapState('backOffice/steps', ['tax', 'mount', 'totalPrice']),
    isSummary() {
      return this.place == 'summary'
    },

    card() {
      return this.$store.state.backOffice.steps.card
    },
  },
  methods: {
    formatNumber(number) {
      return currencyFormat(number, currencyFormatStyleEnum.DECIMAL)
    },
  },
}
</script>

<style lang="scss"></style>
